module.exports = __webpack_public_path__ + "tr.f253a02f955e87805ffa.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/tr.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/tr.svg
// module chunks = styles